import { List, Record } from 'immutable';
import { createSelector } from '@opengov/compose-app/reselect';
import { sessionSelector } from './actionsAndReducer';
import {
  getReportingAdminClaimStatus,
  getReportingManagerPrivilegeClaimStatus,
  getReportingEntitlementClaimStatus
} from '../claims/selectors';

export const getSession = createSelector(sessionSelector, (state) => state.session);
export const getUserUuid = createSelector(getSession, (session) => session.uuid);
export const getSessionUUID = createSelector(sessionSelector, (state) => state.session.uuid);
export const getSessionEntity = createSelector(getSession, (session) => session.entity);
export const getSessionEntityId = createSelector(getSessionEntity, (session) => session.entity_id);
export const getSessionEntitySubdomain = createSelector(getSessionEntity, (session) => session.subdomain);
export const getSessionRoleName = createSelector(getSession, (session) => session.role.name);
export const getGroups = createSelector(getSession, (session) => session.groups);
export const getSessionEnvironment = createSelector(getSession, (session) => session.environment);
export const canSwitchEntities = createSelector(
  getSession,
  (session) => session && session.abilities && session.abilities.entity && session.abilities.entity.switch_to
);
export const canCreateEntity = createSelector(
  getSession,
  (session) => session && session.abilities && session.abilities.entity && session.abilities.entity.create
);
export const isOpenGovRole = createSelector(getSessionRoleName, (role) => /^opengov_.*/.test(role) || false);
export const isOpenGovAdmin = createSelector(getSessionRoleName, (role) => role === 'opengov_admin');
export const isEntityUser = getReportingEntitlementClaimStatus;
export const userSelector = createSelector(getSession, ({ id, first_name, last_name, full_name, email, title, uuid }) =>
  Record({ id, first_name, last_name, full_name, email, title, uuid })()
);
export const sessionFeaturePermissionSelector = createSelector(
  getSession,
  (session) => session.entity.feature_permissions
);
export const menuItemsSelector = createSelector(getSession, (session) => List(session.control_panel_menu_items));
export const selectAbilities = createSelector(getSession, (session) => session.abilities);
export const can = (abilities, target) => !!abilities && abilities[target];
export const selectCanUpdate = (abilities) => can(abilities, 'update');
export const selectCanCreate = (abilities): boolean => can(abilities, 'create');
export const selectReportAbilities = createSelector(selectAbilities, (abilities) => abilities.report);
export const isEntityAdminRole = getReportingManagerPrivilegeClaimStatus;
export const isReportingAdminGroup = getReportingAdminClaimStatus;
export const isEntityGroupPartnerRole = getReportingAdminClaimStatus;
export const selectCanUpdateDashboardTiles = createSelector(
  isOpenGovRole,
  isEntityAdminRole,
  isReportingAdminGroup,
  (openGovRole, entityAdminRole, reportingAdminGroup) => !!(openGovRole || entityAdminRole || reportingAdminGroup)
);
